import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService, ResponseService } from '../base.service';
import { AppErrorLogViewModel } from '@src/app/models/app-logs/app-error-log.model';
import { AppErrorLogParams } from '@src/app/models/app-logs/app-error-log-params.model';
import { AppErrorLogDashboard } from '@src/app/models/app-logs/app-error-log-dashboard.model';
import { ResolveErrorDTO } from '@src/app/models/app-logs/resolve-error.dto';
import { CreateAppErrorLogDTO } from '@src/app/models/app-logs/create-app-error-log.dto';

@Injectable({
  providedIn: 'root',
})
export class AppErrorLogService extends BaseService {
  private readonly endpoint = `${this.baseUrl}/AppErrorLog`;

  constructor(http: HttpClient) {
    super(http);
  }

  registrar(dto: CreateAppErrorLogDTO): Observable<ResponseService<unknown>> {
    return this.http.post(this.endpoint, dto) as Observable<ResponseService<unknown>>;
  }

  listar(
    parametros: AppErrorLogParams
  ): Observable<ResponseService<AppErrorLogViewModel[]>> {
    let params = new HttpParams();

    Object.keys(parametros).forEach((key) => {
      const value = (parametros as any)[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.append(key, value);
      }
    });

    return this.http.get(this.endpoint, { params }) as Observable<
      ResponseService<AppErrorLogViewModel[]>
    >;
  }

  buscarPorId(id: number): Observable<ResponseService<AppErrorLogViewModel>> {
    return this.http.get(`${this.endpoint}/${id}`) as Observable<
      ResponseService<AppErrorLogViewModel>
    >;
  }

  resolver(
    id: number,
    dto: ResolveErrorDTO
  ): Observable<ResponseService<boolean>> {
    return this.http.post(
      `${this.endpoint}/${id}/resolver`,
      dto
    ) as Observable<ResponseService<boolean>>;
  }

  dashboard(): Observable<ResponseService<AppErrorLogDashboard>> {
    return this.http.get(`${this.endpoint}/dashboard`) as Observable<
      ResponseService<AppErrorLogDashboard>
    >;
  }
}
